export const getSaintJosephData = () => ({
  name: "Saint-Joseph",
  region: "Rhône",
  country: "France",
  description: "Saint-Joseph est une appellation importante du Rhône septentrional, produisant des vins rouges élégants et des vins blancs aromatiques sur une longue bande de vignobles.",
  type: "subregion",
  area: "1,200 ha",
  production: "60,000 hectolitres",
  mapAreas: [
    { region: "Saint-Joseph", x: 53, y: 65, color: "#4B164C", size: 5 }
  ],
  characteristics: {
    climate: "Climat continental avec influence méditerranéenne",
    soil: "Sols de granit, schiste et micaschiste",
    viticulture: "Viticulture en terrasses, vendanges manuelles, rendements limités"
  },
  wineStyles: {
    red: "Vins rouges élégants et équilibrés, avec des notes de fruits rouges et d'épices",
    white: "Vins blancs aromatiques et complexes, avec des notes de fleurs blanches"
  },
  history: "Saint-Joseph produit des vins depuis l'époque romaine. L'appellation est reconnue depuis 1956. Le vignoble s'étend sur une longue bande le long du Rhône.",
  foodPairing: "Viandes rouges, volailles, fromages affinés, cuisine gastronomique",
  grapeVarieties: [
    {
      name: "Syrah",
      percentage: "90%",
      description: "Cépage principal pour les vins rouges, produisant des vins élégants et équilibrés",
      characteristics: "Élégant, équilibré, tanins soyeux, notes de fruits rouges et d'épices",
      wineStyles: "Sec, moyen-corps, équilibré"
    },
    {
      name: "Marsanne",
      percentage: "7%",
      description: "Cépage principal pour les vins blancs, apportant richesse et complexité",
      characteristics: "Riche, complexe, notes de fleurs blanches et de fruits secs",
      wineStyles: "Sec, plein-corps, complexe"
    },
    {
      name: "Roussanne",
      percentage: "3%",
      description: "Cépage d'assemblage pour les vins blancs, apportant élégance et aromatique",
      characteristics: "Élégant, aromatique, notes florales et d'agrumes",
      wineStyles: "Sec, moyen-corps, aromatique"
    }
  ]
}); 